// src/app/auth/token.interceptor.ts

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AppCommunicationService } from '../services/app-communication.service';
import { AuthenticationService } from '../services/authentication.service';

import * as _ from 'lodash';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private _authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = AppCommunicationService.getCurrentUser();
        const headersToSet = {};

        if (request.headers) {
            if (!request.headers.has('Content-Type')) {
                headersToSet['Content-Type'] = 'application/json';
            }

            if (currentUser) {
                const token = currentUser.access_token;

                if (token && !request.headers.has('Authorization')) {
                    headersToSet['Authorization'] = 'Bearer ' + token;
                }
            }
        }
        
        request = request.clone({
            setHeaders: headersToSet
        });

        return next.handle(request);
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/interceptors/token.interceptor.ts